<template>
  <div class="alignCenter">
    <van-nav-bar left-arrow @click-left="goback" left-text="" class="disclaimerTitle">
      <slot slot="title">
        <span class="title">免责声明</span>
      </slot>
    </van-nav-bar>
    <div class="updateDate">
      更新日期：2020年11月11日
    </div>
    <div class="content">
      <article>
        本次活动为医疗体检活动，具有一定的危险性和不可预知性。参加者承诺提供的个人信息准确，对自己的行为及后果负完全责任。活动方不对任何由体检本身具有的风险以及往返路途中发生的危险所产生的的后果负责。凡参加者均视为具有完全民事行为能力人。
      </article>

    </div>
    
    
  </div>
</template>

<script type="text/ecmascript-6">

export default {
  name: "disclaimer",
  data() {
    return {
      
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
  },
  // 里面的函数只有调用才会执行
  methods: {
    goback(){
       this.$router.go(-1);
    },
  },
};
</script>

<style lang=less scoped>
.van-nav-bar{
  background:linear-gradient(to right, #FFFFFf, #FFFFFF);
}

.title{
  /* font-family: 'PingFang-SC-Semibold'; */
}

.disclaimerTitle{
  box-shadow: 0px 0px 10px gray;
}
.updateDate{
  margin-top:20px;
  padding:20px 40px 10px 40px;
  text-align:right;
  color:#9B9B9B;
  font-size:14px;
  /* font-family: 'PingFang-SC-Semibold'; */
}
.content{
  left: 39px;
  top: 199px;
  line-height: 35px;
  color: rgba(38, 38, 39, 100);
  font-size: 16px;
  text-align: justify;
  /* font-family: 'PingFang-SC-Semibold'; */
  font-weight:550;
  padding:10px 40px 10px 40px;
}
article{
  text-indent:2em;
}
</style>